import { Component, ViewContainerRef } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

// import { DatatransferService } from './dashboard/dashboard2/datatransfer.service';
// import { TempService } from './forms/elements/temperature/temp.service';

// import { Chart } from 'chart.js';
// import { myData } from './data.model';

// import { myData } from './data.model';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})


export class AppComponent {

    // chart = []; 
    // chart2 = []; 
    //Set toastr container ref configuration for toastr positioning on screen

    // constructor(public toastr: ToastsManager, vRef: ViewContainerRef, private _data: DatatransferService,  private _data2: TempService) {
    constructor(public toastr: ToastsManager, vRef: ViewContainerRef) {
        this.toastr.setRootViewContainerRef(vRef);
    }
    // constructor(public toastr: ToastsManager, vRef: ViewContainerRef, _data :DatatransferService) {
    //     this.toastr.setRootViewContainerRef(vRef);
    // }
        
    // public apps : myData[];    

    // ngOnInit() {

        // this._data2.tempReading()
        //     .subscribe(res => {
              
        //      //console.log(res, "my temperatures")

    //     //     })
            
    //         this._data.dailyForecast()
    //         .subscribe(res => {
    //           ////console.log(res)
                
    //             let myArray = [];
                
    //             this.apps = res as myData[];
                
    //             for(let a of this.apps){
    //                 ////console.log(a.Timestamp,a.kWhrs);
    //             }

    //             // let location = res
    //             // let test_location = { "location" : res , "value" : res };
    //             ////console.log(location);
    //             ////console.log(res.valueOf);

    //             // let temp_min = res['list'].map(res => res.main.temp_min);
    //             // let alldates = res['list'].map(res => res.timestamp)

    //             // my_data.kWhrs = res.valueOf(0)  ;

    //             // my_data
    //             // let weatherDates = []
    //             // my_data.forEach((res) => {
    //             //     let jsdate = new Date(res * 1000)
    //             //     weatherDates.push(jsdate.toLocaleTimeString('en', { year: 'numeric', month: 'short', day: 'numeric' }))
    //             // })

    //             ////console.log(location);
    //             ////console.log(temp);
    //             ////console.log(deveui);


          
                
    //         })
    // }

// }

// interface myData {
//     Timestamp : number
//     kWhrs : string
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts